/*eslint-disable*/

import React from "react";

// Black
import black_thermometer from "../../assets/weather/black/thermometer.png"
import black_humidity from "../../assets/weather/black/humidity.png"
import black_sunset from "../../assets/weather/black/sunset.png"
import black_01d from "../../assets/weather/black/01d.png"
import black_01n from "../../assets/weather/black/01n.png"
import black_02d from "../../assets/weather/black/02d.png"
import black_02n from "../../assets/weather/black/02n.png"
import black_03d from "../../assets/weather/black/03d.png"
import black_03n from "../../assets/weather/black/03n.png"
import black_04d from "../../assets/weather/black/04d.png"
import black_04n from "../../assets/weather/black/04n.png"
import black_09d from "../../assets/weather/black/09d.png"
import black_09n from "../../assets/weather/black/09n.png"
import black_10d from "../../assets/weather/black/10d.png"
import black_10n from "../../assets/weather/black/10n.png"
import black_11d from "../../assets/weather/black/11d.png"
import black_11n from "../../assets/weather/black/11n.png"
import black_13d from "../../assets/weather/black/13d.png"
import black_13n from "../../assets/weather/black/13n.png"
import black_50d from "../../assets/weather/black/50d.png"
import black_50n from "../../assets/weather/black/50n.png"

// White

import white_thermometer from "../../assets/weather/white/thermometer.png"
import white_humidity from "../../assets/weather/white/humidity.png"
import white_sunset from "../../assets/weather/white/sunset.png"
import white_01d from "../../assets/weather/white/01d.png"
import white_01n from "../../assets/weather/white/01n.png"
import white_02d from "../../assets/weather/white/02d.png"
import white_02n from "../../assets/weather/white/02n.png"
import white_03d from "../../assets/weather/white/03d.png"
import white_03n from "../../assets/weather/white/03n.png"
import white_04d from "../../assets/weather/white/04d.png"
import white_04n from "../../assets/weather/white/04n.png"
import white_09d from "../../assets/weather/white/09d.png"
import white_09n from "../../assets/weather/white/09n.png"
import white_10d from "../../assets/weather/white/10d.png"
import white_10n from "../../assets/weather/white/10n.png"
import white_11d from "../../assets/weather/white/11d.png"
import white_11n from "../../assets/weather/white/11n.png"
import white_13d from "../../assets/weather/white/13d.png"
import white_13n from "../../assets/weather/white/13n.png"
import white_50d from "../../assets/weather/white/50d.png"
import white_50n from "../../assets/weather/white/50n.png"



class WeatherIcon extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
          color: this.props.color==="Light"?1:0, //1 = light , 0 = dark
        };
    }


    componentDidUpdate(prevProps) {
      // Typical usage (don't forget to compare props):
      if (this.props.color !== prevProps.color) {
        this.setState({
          color: this.props.color==="Light"?1:0,
        })
      }
    }

    getWhiteIcon(id){
      switch(id){
        case "thermometer":
          return(<img src={white_thermometer} alt="Logo" style={{height:"100%"}}/>);
        case "humidity":
          return(<img src={white_humidity} alt="Logo" style={{height:"100%"}}/>);
        case "sunset":
          return(<img src={white_sunset} alt="Logo" style={{height:"100%"}}/>);
        case "01d":
          return(<img src={white_01d} alt="Logo" style={{height:"100%"}}/>);
        case "01n":
          return(<img src={white_01n} alt="Logo" style={{height:"100%"}}/>);
        case "02d":
          return(<img src={white_02d} alt="Logo" style={{height:"100%"}}/>);
        case "02n":
          return(<img src={white_02n} alt="Logo" style={{height:"100%"}}/>);
        case "03d":
          return(<img src={white_03d} alt="Logo" style={{height:"100%"}}/>);
        case "03n":
          return(<img src={white_03n} alt="Logo" style={{height:"100%"}}/>);
        case "04d":
          return(<img src={white_04d} alt="Logo" style={{height:"100%"}}/>);
        case "04n":
          return(<img src={white_04n} alt="Logo" style={{height:"100%"}}/>);
        case "09d":
          return(<img src={white_09d} alt="Logo" style={{height:"100%"}}/>);
        case "09n":
          return(<img src={white_09n} alt="Logo" style={{height:"100%"}}/>);
        case "10d":
          return(<img src={white_10d} alt="Logo" style={{height:"100%"}}/>);
        case "10n":
          return(<img src={white_10n} alt="Logo" style={{height:"100%"}}/>);
        case "11d":
          return(<img src={white_11d} alt="Logo" style={{height:"100%"}}/>);
        case "11n":
          return(<img src={white_11n} alt="Logo" style={{height:"100%"}}/>);
        case "13d":
          return(<img src={white_13d} alt="Logo" style={{height:"100%"}}/>);
        case "13n":
          return(<img src={white_13n} alt="Logo" style={{height:"100%"}}/>);
        case "50d":
          return(<img src={white_50d} alt="Logo" style={{height:"100%"}}/>);
        case "50n":
          return(<img src={white_50n} alt="Logo" style={{height:"100%"}}/>);
        default:
          break;
      }
    }

    getBlackIcon(id){
      switch(id){
        case "thermometer":
          return(<img src={black_thermometer} alt="Logo" style={{height:"100%"}}/>);
        case "humidity":
          return(<img src={black_humidity} alt="Logo" style={{height:"100%"}}/>);
        case "sunset":
          return(<img src={black_sunset} alt="Logo" style={{height:"100%"}}/>);
        case "01d":
          return(<img src={black_01d} alt="Logo" style={{height:"100%"}}/>);
        case "01n":
          return(<img src={black_01n} alt="Logo" style={{height:"100%"}}/>);
        case "02d":
          return(<img src={black_02d} alt="Logo" style={{height:"100%"}}/>);
        case "02n":
          return(<img src={black_02n} alt="Logo" style={{height:"100%"}}/>);
        case "03d":
          return(<img src={black_03d} alt="Logo" style={{height:"100%"}}/>);
        case "03n":
          return(<img src={black_03n} alt="Logo" style={{height:"100%"}}/>);
        case "04d":
          return(<img src={black_04d} alt="Logo" style={{height:"100%"}}/>);
        case "04n":
          return(<img src={black_04n} alt="Logo" style={{height:"100%"}}/>);
        case "09d":
          return(<img src={black_09d} alt="Logo" style={{height:"100%"}}/>);
        case "09n":
          return(<img src={black_09n} alt="Logo" style={{height:"100%"}}/>);
        case "10d":
          return(<img src={black_10d} alt="Logo" style={{height:"100%"}}/>);
        case "10n":
          return(<img src={black_10n} alt="Logo" style={{height:"100%"}}/>);
        case "11d":
          return(<img src={black_11d} alt="Logo" style={{height:"100%"}}/>);
        case "11n":
          return(<img src={black_11n} alt="Logo" style={{height:"100%"}}/>);
        case "13d":
          return(<img src={black_13d} alt="Logo" style={{height:"100%"}}/>);
        case "13n":
          return(<img src={black_13n} alt="Logo" style={{height:"100%"}}/>);
        case "50d":
          return(<img src={black_50d} alt="Logo" style={{height:"100%"}}/>);
        case "50n":
          return(<img src={black_50n} alt="Logo" style={{height:"100%"}}/>);
        default:
          break;
      }
    }

    render() {
        return (
            <>
              {this.state.color?this.getBlackIcon(this.props.id):this.getWhiteIcon(this.props.id)}
            </>
        );
    }
}

 export default WeatherIcon
